/* eslint-disable no-unused-vars */
import { DatePicker } from 'antd'
import dayjs, { Dayjs } from 'dayjs'
import React, { Dispatch, SetStateAction } from 'react'
import { Left, Right } from '../../../iconsV2'
import { CalendarMode } from '../../../types'
import Button from '../common/Button'
import Icon from '../common/Icon'
// TODO: config đường dẫn dạng @utils, @component,... tương ứng với folder nào ( sửa tất cả e nhé)
import { customDateFormat } from '../../../utils'
import styles from '../SAPPCalendar.module.css'

interface IHeaderCalendarProps {
  title?: string
  showTeacherName?: boolean
  currentDate: Dayjs
  setCurrentDate: Dispatch<SetStateAction<Dayjs>>
  calendarMode: CalendarMode
  setCalendarMode: Dispatch<SetStateAction<CalendarMode>>
}

const HeaderCalendar = ({
  title,
  showTeacherName,
  currentDate,
  setCurrentDate,
  calendarMode,
  setCalendarMode
}: IHeaderCalendarProps) => {
  const handleChangeDate = (date: Dayjs) => {
    setCurrentDate(date)
  }

  const handleChangeMode = (mode: CalendarMode) => {
    setCalendarMode(mode)
    setCurrentDate(currentDate.startOf('month'))
  }

  return (
    <div>
      <div className={styles['header-calendar']}>
        <div className={styles['header-calendar__nav']}>
          <Icon
            icon={<Left />}
            onClick={() =>
              handleChangeDate(currentDate.subtract(1, calendarMode))
            }
          />
          <DatePicker
            picker={calendarMode === 'day' ? 'date' : calendarMode}
            onChange={handleChangeDate}
            format={(value) => customDateFormat(value, 'MMMM, YYYY')}
            value={currentDate}
            allowClear={false}
            suffixIcon={null}
            className={styles['header-calendar__date-picker']}
            size='large'
          />
          <Icon
            icon={<Right />}
            onClick={() => handleChangeDate(currentDate.add(1, calendarMode))}
          />
        </div>
        {showTeacherName && (
          <div className={styles['header-calendar__title']}>{title}</div>
        )}
        <div className={styles['header-calendar__controls']}>
          <Button onClick={() => handleChangeDate(dayjs())}>Today</Button>
          <div className={styles['header-calendar__divider']} />
          <Button
            color={calendarMode === 'month' ? 'primary' : 'default'}
            onClick={() => handleChangeMode('month')}
          >
            Month
          </Button>
          <Button
            color={calendarMode === 'week' ? 'primary' : 'default'}
            onClick={() => handleChangeMode('week')}
          >
            Week
          </Button>
        </div>
      </div>
    </div>
  )
}

export default HeaderCalendar
